export default __webpack_public_path__ + "static/media/right_digit.175fbf3c.png";